import { useEffect } from 'react'
import { useDocumentState } from '@/state/document'

const SELECT_KEYS = ['Shift', 'Control', 'Meta']

export const useMultiSelectKeyListener = () => {
  const setIsSelectKeyPressed = useDocumentState(
    (state) => state.setIsSelectKeyPressed,
  )

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (SELECT_KEYS.includes(e.key)) {
        setIsSelectKeyPressed(true)
      }
    }

    const onKeyUp = (e: KeyboardEvent) => {
      if (SELECT_KEYS.includes(e.key)) {
        setIsSelectKeyPressed(false)
      }
    }

    const onBlur = () => {
      setIsSelectKeyPressed(false)
    }

    window.addEventListener('keydown', onKeyDown)
    window.addEventListener('keyup', onKeyUp)
    window.addEventListener('blur', onBlur)

    return () => {
      window.removeEventListener('keydown', onKeyDown)
      window.removeEventListener('keyup', onKeyUp)
      window.removeEventListener('blur', onBlur)
    }
  }, [setIsSelectKeyPressed])
}
